<template>
    <a-modal centered :visible="visible" title="批量修改价格" @ok="on_submit" @cancel="cancel" :confirmLoading="submitting" :width="420">
        <a-form-model :model="form" ref="trademark_price" :rules="rules">
            <div class="ids" v-if="record">
                <div style="color: #ff5722;margin-bottom:12px">已选择：{{ record.length }}个商标</div>
                <small>{{ this.record.map((v) => v.markName).join("，") }}</small>
            </div>

            <a-divider>修改价格为</a-divider>

            <a-input-number v-model="form.price" style="width:100%"></a-input-number>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        apply_nos: null,
        price: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                form: {},
                loading: false,
                data_supplier: [],
                rules: {
                    supplier_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入链接",
                        },
                    ],
                },
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    this.form.apply_nos = this.record.map((v) => v.applyNo);
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["trademark_price"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/trademark/batch_price", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch()
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.$refs["trademark_price"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
